import { PlayerLayout } from "@/shared/layouts/PlayerLayout/PlayerLayout";
import { Main } from "@/pages/PlayerPage/ui/Main";
import { LanguageSwitcher } from "@/components/locale/LanguageSwitcher";
import React from "react";
import { PlayerStoreProvider } from "@/features/player/model/context";
import { AvatarSideBar } from "@/pages/PlayerPage/ui/AvatarSideBar";

export const PlayerPage = () => {
    return (
        <PlayerStoreProvider>
            <PlayerLayout
                Header={<LanguageSwitcher />}
                Main={<Main />}
                Sidebar={<AvatarSideBar />}
            />
        </PlayerStoreProvider>
    );
};
